import { getAPI, postAPI, putAPI } from "../../../../api/apis";
import { REACT_APP_CANDIDATE ,  REACT_APP_PROFILE} from "../../../../utils/common";




export async function getSkillBasedTests(data: any){
    const Details = postAPI(  REACT_APP_PROFILE + `/test-list`, data)
    return Details
}

export async function getQuestions() {
    const Details = getAPI( REACT_APP_CANDIDATE + '/survey-questions')
    return Details
}

export async function updateSurveyData(body: any) {
    const Details = putAPI( REACT_APP_CANDIDATE + '/survey-data', body)
    return Details
}
